import { render, staticRenderFns } from "./AddSlider.vue?vue&type=template&id=87080c26&scoped=true&"
import script from "./AddSlider.vue?vue&type=script&lang=js&"
export * from "./AddSlider.vue?vue&type=script&lang=js&"
import style0 from "./AddSlider.vue?vue&type=style&index=0&id=87080c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87080c26",
  null
  
)

export default component.exports